import React, { useState, useMemo } from "react";
import AllSlidersContext from "./AllSlidersContext";

const AllSlidersState = (props) => {
  const [state, setState] = useState([]);
  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );

  return (
    <AllSlidersContext.Provider value={value}>
      {props.children}
    </AllSlidersContext.Provider>
  );
};

export default AllSlidersState;
